import { getProcessedOrder } from "./getProcessedOrder";
export const getProcessedOrders = ({ orders }) => {
    return orders.map((order) => {
        return getProcessedOrder({ order });
    });
};